import { render, staticRenderFns } from "./app-help.vue?vue&type=template&id=56e21c3d&"
import script from "./app-help.vue?vue&type=script&lang=js&"
export * from "./app-help.vue?vue&type=script&lang=js&"
import style0 from "./app-help.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports